import { InjectionToken, Provider } from "@angular/core";
import { LISService } from "src/app/services/+products/lis/lis.service";
import { MedicaidService } from "src/app/services/+products/medicaid/medicaid.service";
import { SNAPService } from "src/app/services/+products/snap/snap.service";
import { SSIService } from "src/app/services/+products/ssi/ssi.service";
import { VeteranService } from "src/app/services/+products/veteran/veteran.service";
import { CommunityService } from "src/app/services/community.service";
import {
    caseAdvanceStageActionExecutor,
    commandActionHandler,
    executeFunctionActionHandler,
    hideOverlayPanelActionHandler,
    loadComponentActionHandlerV2,
    loadContextDataActionHandler,
    showOverlayPanelActionHandler
} from './app-action-handlers';
import { IActionHandler } from "./smart-icon.models";

// Handlers
export const ActionTypes: Map<string, IActionHandler> = new Map<string, IActionHandler>([
    // ['load-component-action-handler', loadComponentActionHandler],
    ['COMPONENT', loadComponentActionHandlerV2],

    ['INVOKE', executeFunctionActionHandler],
    ['COMMAND', commandActionHandler],
    ['OVERLAY', showOverlayPanelActionHandler],
    ['hide-overlaypanel-action-handler', hideOverlayPanelActionHandler],
    ['CONTEXT', loadContextDataActionHandler],
]);
export const ACTION_HANDLERS = new InjectionToken<Map<string, IActionHandler>>('app.action.handlers', { providedIn: 'root', factory: () => ActionTypes });

// Dependency Injection Tokens for Action Handlers
export const ActionHandlersDIMapping = new Map<string, InjectionToken<any>>([
    // Services
    ['community-service', new InjectionToken('community-service-token')],
    ['medicaid-service', new InjectionToken('medicaid-service-token')],
    ['lis-service', new InjectionToken('lis-service-token')],
    ['snap-service', new InjectionToken('snap-service-token')],
    ['veteran-service', new InjectionToken('veteran-service-token')],
    ['ssi-service', new InjectionToken('ssi-service-token')],
    ['CASEADVANCEINVOKER', new InjectionToken('case-advance-invoker-token')],
]);

// Dependency Injection definition for Action Handlers. Using Tokens and existing services/components
export const ActionHandlerDIProviders: Provider[] = [
    // Services
    { provide: ActionHandlersDIMapping.get('community-service'), useExisting: CommunityService },
    { provide: ActionHandlersDIMapping.get('medicaid-service'), useExisting: MedicaidService },
    { provide: ActionHandlersDIMapping.get('lis-service'), useExisting: LISService },
    { provide: ActionHandlersDIMapping.get('snap-service'), useExisting: SNAPService },
    { provide: ActionHandlersDIMapping.get('veteran-service'), useExisting: VeteranService },
    { provide: ActionHandlersDIMapping.get('ssi-service'), useExisting: SSIService },

    { provide: ActionHandlersDIMapping.get('CASEADVANCEINVOKER'), useFactory: () => caseAdvanceStageActionExecutor, multi: false },

];
